/**
 * Safari-Compatible Date Parsing Utilities
 * 
 * Safari has different date parsing behavior compared to other browsers.
 * This utility provides Safari-compatible date parsing to ensure consistent
 * date display across all browsers.
 */

/**
 * Safari-compatible date parsing utility
 * Safari is more strict about date string formats and interprets date-only strings as UTC
 */
export const parseDateSafariCompatible = (dateString: string): Date => {
  if (!dateString) return new Date();
  
  // If it's a full datetime string with space separator
  if (dateString.includes(' ')) {
    // Convert "2025-09-27 09:30:00" to "2025-09-27T09:30:00"
    return new Date(dateString.replace(' ', 'T'));
  }
  
  // If it's a date-only string, Safari interprets this as UTC midnight
  // Add explicit time to avoid timezone interpretation issues
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    // Use noon to avoid DST transition issues
    return new Date(dateString + 'T12:00:00');
  }
  
  // If it's already in ISO format or other format, parse directly
  return new Date(dateString);
};


